module.exports = __webpack_public_path__ + "images/stickers/smile.90a8856b7465d57b1ac3.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/smile.png
// module id = y0Dl
// module chunks = 2